import { useEffect, useRef } from "react";

export function useDocumentTitle(title: string) {
  const prev = useRef<string | null>(null);

  useEffect(() => {
    prev.current ??= document.title;
    if (document.title !== title) {
      document.title = title;
    }
    return () => {
      if (prev.current !== null) {
        document.title = prev.current;
      }
    };
  }, [title]);
}
